import { useState } from "react";
import { Box, Collapse, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

const CustomTableRow = (props) => {
    const { row } = props;
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }} onClick={() => setOpen(!open)}>
                <TableCell align="left">{new Date(row.date).toLocaleDateString("de-GE")}</TableCell>
                <TableCell align="right">{row.totalTime}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={0}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right">Check In</TableCell>
                                        <TableCell align="right">Check Out</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow key={row.id}>
                                        <TableCell align="right">
                                            {new Date(row.checkIn).toLocaleDateString("de-GE")}
                                            <br />
                                            {new Date(row.checkIn).toLocaleTimeString("en-GB").slice(0, 5)}
                                        </TableCell>
                                        <TableCell align="right">
                                            {new Date(row.checkOut).toLocaleDateString("de-GE")}
                                            <br />
                                            {new Date(row.checkOut).toLocaleTimeString("en-GB").slice(0, 5)}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default CustomTableRow;
